import { Services, getServiceNameKebabCase, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'

export const serviceNameViaPoint = getServiceNameViaPoint(Services['url-shortener-settings/presets'])
export const serviceNameKebabCase = getServiceNameKebabCase(Services['url-shortener-settings/presets'])
